import { OfflineStatus } from "@rumble-it/common-components/components/OfflineStatus";
import FormContainerSuccess from "./form-container-success";

export const DealerIntakeFormSuccess = () => {
  // TODO: Move all logic related to fetching data for the DealerIntakeForm here,
  // so that the FormContainer is only responsible for rendering the form and the form state,
  // independent of whether it is for the widget or the dealer intake form.
  return (
    <>
      <div className="flex flex-col items-center mb-8 px-5">
        <OfflineStatus />

        <div className="rounded-lg min-w-[800px]">
          <FormContainerSuccess
            formType="repair-direct-generic-dealer-intake"
            formSchemaKey="onSuccess"
          />
        </div>
      </div>
    </>
  );
};

export default DealerIntakeFormSuccess;
